// Reservation Summary KPIs
export const FETCH_RESERVATION_SUMMARY_REQUEST = 'reports/reservationReport/FETCH_RESERVATION_SUMMARY_REQUEST';
export const FETCH_RESERVATION_SUMMARY_SUCCESS = 'reports/reservationReport/FETCH_RESERVATION_SUMMARY_SUCCESS';
export const FETCH_RESERVATION_SUMMARY_FAILURE = 'reports/reservationReport/FETCH_RESERVATION_SUMMARY_FAILURE';

// Checkin KPIs
export const FETCH_RESERVATION_CHECKIN_KPI_REQUEST = 'reports/reservationReport/FETCH_RESERVATION_CHECKIN_KPI_REQUEST';
export const FETCH_RESERVATION_CHECKIN_KPI_SUCCESS = 'reports/reservationReport/FETCH_RESERVATION_CHECKIN_KPI_SUCCESS';
export const FETCH_RESERVATION_CHECKIN_KPI_FAILURE = 'reports/reservationReport/FETCH_RESERVATION_CHECKIN_KPI_FAILURE';

// Reservation Log (server-paginated)
export const FETCH_RESERVATION_LOG_REQUEST = 'reports/reservationReport/FETCH_RESERVATION_LOG_REQUEST';
export const FETCH_RESERVATION_LOG_SUCCESS = 'reports/reservationReport/FETCH_RESERVATION_LOG_SUCCESS';
export const FETCH_RESERVATION_LOG_FAILURE = 'reports/reservationReport/FETCH_RESERVATION_LOG_FAILURE';

// Reservation Detail
export const FETCH_RESERVATION_DETAIL_REQUEST = 'reports/reservationReport/FETCH_RESERVATION_DETAIL_REQUEST';
export const FETCH_RESERVATION_DETAIL_SUCCESS = 'reports/reservationReport/FETCH_RESERVATION_DETAIL_SUCCESS';
export const FETCH_RESERVATION_DETAIL_FAILURE = 'reports/reservationReport/FETCH_RESERVATION_DETAIL_FAILURE';
export const CLEAR_RESERVATION_DETAIL = 'reports/reservationReport/CLEAR_RESERVATION_DETAIL';

// Reservation By Status breakdown
export const FETCH_RESERVATION_BY_STATUS_REQUEST = 'reports/reservationReport/FETCH_RESERVATION_BY_STATUS_REQUEST';
export const FETCH_RESERVATION_BY_STATUS_SUCCESS = 'reports/reservationReport/FETCH_RESERVATION_BY_STATUS_SUCCESS';
export const FETCH_RESERVATION_BY_STATUS_FAILURE = 'reports/reservationReport/FETCH_RESERVATION_BY_STATUS_FAILURE';

// Hourly Reservations
export const FETCH_RESERVATION_HOURLY_REQUEST = 'reports/reservationReport/FETCH_RESERVATION_HOURLY_REQUEST';
export const FETCH_RESERVATION_HOURLY_SUCCESS = 'reports/reservationReport/FETCH_RESERVATION_HOURLY_SUCCESS';
export const FETCH_RESERVATION_HOURLY_FAILURE = 'reports/reservationReport/FETCH_RESERVATION_HOURLY_FAILURE';

// Today New Details (server-paginated table)
export const FETCH_TODAY_NEW_DETAILS_REQUEST = 'reports/reservationReport/FETCH_TODAY_NEW_DETAILS_REQUEST';
export const FETCH_TODAY_NEW_DETAILS_SUCCESS = 'reports/reservationReport/FETCH_TODAY_NEW_DETAILS_SUCCESS';
export const FETCH_TODAY_NEW_DETAILS_FAILURE = 'reports/reservationReport/FETCH_TODAY_NEW_DETAILS_FAILURE';
